export default "__VITE_PUBLIC_ASSET__1dc9b1fe__"